import { render, staticRenderFns } from "./RenderAddress.vue?vue&type=template&id=628da5c9&"
import script from "./RenderAddress.vue?vue&type=script&lang=js&"
export * from "./RenderAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports